import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { CopyButton } from '../../../../../components/ui/CopyButton.jsx';
import { useActionPromptContext } from './ActionPromptContext.tsx';

export const DevSection = () => {
  const { currentStatus, step } = useActionPromptContext();

  if (!import.meta.env.DEV || !import.meta.env.VITE_DEBUG) {
    return null;
  }

  return (
    <Accordion
      onChange={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      sx={{
        p: 0,
        bgcolor: 'divider',
        borderRadius: 1,
      }}
    >
      <AccordionSummary>Dev Section</AccordionSummary>
      <AccordionDetails>
        <div>
          <CopyButton noHighlight textToCopy={step.id}>
            Step Id: {step.id}
          </CopyButton>
        </div>
        <pre>step: {JSON.stringify(step, null, 2)}</pre>
        <pre>currentStatus: {JSON.stringify(currentStatus, null, 2)}</pre>
      </AccordionDetails>
    </Accordion>
  );
};
